import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "../../utils/toast";
import testSampleTypeService from "../../services/testSampleTypeService";

export const fetchTestSampleTypes = createAsyncThunk(
  "testSampleTypes/fetchTestSampleTypes",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await testSampleTypeService.getAll(filters);
      return response.data.data;
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to fetch test sample types";
      toast.error(errorMsg);
      return rejectWithValue(errorMsg);
    }
  }
);

export const fetchTestSampleTypesByTest = createAsyncThunk(
  "testSampleTypes/fetchTestSampleTypesByTest",
  async (testId, { rejectWithValue }) => {
    try {
      const response = await testSampleTypeService.getAll({ test_id: testId });
      return { testId, rows: response.data.data };
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to fetch test sample types";
      toast.error(errorMsg);
      return rejectWithValue(errorMsg);
    }
  }
);

const testSampleTypeSlice = createSlice({
  name: "testSampleTypes",
  initialState: {
    rows: [],
    byTest: {},
    loading: false,
    error: null,
  },
  reducers: {
    clearTestSampleTypeError: (state) => {
      state.error = null;
    },
    clearByTest: (state, action) => {
      const testId = action.payload;
      delete state.byTest[testId];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestSampleTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTestSampleTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload;
      })
      .addCase(fetchTestSampleTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTestSampleTypesByTest.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTestSampleTypesByTest.fulfilled, (state, action) => {
        state.loading = false;
        state.byTest[action.payload.testId] = action.payload.rows;
      })
      .addCase(fetchTestSampleTypesByTest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTestSampleTypeError, clearByTest } =
  testSampleTypeSlice.actions;
export default testSampleTypeSlice.reducer;
